import Styles from 'almanac-ui/Modal/Modals.module.scss'
import { useModals } from 'almanac-ui/Modal/ModalStack'

export const StackButtonsContainer = () => {
  const { setStackButtonsContainer } = useModals()
  return <div className={Styles.stackButtons} ref={setStackButtonsContainer} />
}
